export enum SceneryType {
    Summer = 'summer',
    Winter = 'winter',
    Desert = 'desert',
    Night = 'night',
    Rocky = 'rocky',
}